import equal from "fast-deep-equal";

import updateArticle from "../../articles/updateArticle";

import { WorkMetaData } from "../types/WorkMetaData";

import { isArticleSynced, toArticleValue } from "./workArticleFields";

export default function syncArticlesFromWork(firebase, { work, articles, data, transaction, user }) {
	const metaDataBefore = WorkMetaData.partial().safeParse(work).data || work;
	const metaDataAfter = data ? WorkMetaData.partial().parse(data) : {};

	const updatedKeys = Object.keys(metaDataAfter).filter((key) => !equal(metaDataBefore[key], metaDataAfter[key]));

	if (updatedKeys.length > 0) {
		return Promise.all(
			articles.map((article) => {
				const data = updatedKeys
					.filter((key) => isArticleSynced(key, article, metaDataBefore))
					.reduce(
						(acc, key) => ({ ...acc, [key]: toArticleValue(key, metaDataAfter[key], article.type) }),
						{},
					);

				return updateArticle(firebase, { ref: article.ref, ...data }, { transaction, user });
			}),
		);
	}
}
